'use client'

import { cn } from '@mntn-dev/ui-utilities'
import { Modal, type ModalProps } from '../modal.tsx'
import { FieldModalButtons } from './field-modal-buttons.tsx'
import { FieldModalControls } from './field-modal-controls.tsx'
import { FieldModalMain } from './field-modal-main.tsx'
import { FieldModalTitle } from './field-modal-title.tsx'

type FieldModalProps = ModalProps & {
  className?: string
}

const FieldModalComponent = ({
  children,
  className,
  ...modalProps
}: FieldModalProps) => {
  return (
    <Modal {...modalProps} className={cn('w-5/12', className)}>
      {children}
    </Modal>
  )
}

export const FieldModalNamespace = Object.assign(FieldModalComponent, {
  Title: FieldModalTitle,
  Main: FieldModalMain,
  Controls: FieldModalControls,
  Buttons: FieldModalButtons,
})

export { FieldModalNamespace as FieldModal, type FieldModalProps }
